import configs from '@/config'
import Vue from 'vue'

const actions = {
  getTeamAttributes: {
    method: 'GET',
    url: `${configs.baseUrl}/api/team-attributes`,
  },
  patchTeamAttributes: {
    method: 'PATCH',
    url: `${configs.baseUrl}/api/team-attributes`,
  },
}

let resource

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const getTeamAttributes = async () => {
  if (!resource) initResource()
  const res = await resource.getTeamAttributes()
  return res.body
}

const patchTeamAttributes = async (data) => {
  if (!resource) initResource()
  const res = await resource.patchTeamAttributes({}, data)
  return res.body
}

export default {
  initResource,
  getTeamAttributes,
  patchTeamAttributes,
}
